import { lazy } from 'react';
import Loadable from 'components/Loadable';

const DonationsAdminPage = Loadable(
  lazy(() => import('./components/DonationsAdminPage').then((m) => ({ default: m.DonationsAdminPage })))
);
const CausePage = Loadable(lazy(() => import('./components/Page')));

const donationRoute = {
  path: 'donations',
  children: [
    { path: '', element: <DonationsAdminPage /> },
    { path: 'add', element: <CausePage /> },
    { path: 'edit/:causeId?', element: <CausePage /> },
  ],
};

export default donationRoute;
